import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import { Grid } from "@mui/material";
import { BtnSMGroupStyle, DRxInputStyle, DRxSelectStyle } from "../../Theme";
import DRxSelect from "../../uikit/DRxSelect";
import DRxInput from "../../uikit/DRxInput";
import { Form, Formik, FormikHelpers } from "formik";
import { YSButton } from "../../uikit/YSButton";
import { CircularProgress } from "@mui/material";
import { RxChangeAlertForm } from "../../constants/RxChangeAlerts/rxChangeAlerts";

const initialFormValues: RxChangeAlertForm = {
  reasonDenied: "0",
  refillNotes: "",
  paInformation: "",
};
interface denialObj {
  value: string;
  label: string;
}
export interface MedPrecibeProps {
  denialResons: denialObj[];
  handleSubmit: (
    values: RxChangeAlertForm,
    actions: FormikHelpers<RxChangeAlertForm>
  ) => void;
  actionType: string;
  setActionType: React.Dispatch<React.SetStateAction<string>>;
  rxChangeAlertsRequestData: any;
  medRequestSelectedData: any;
}
const MedPrescribedForm = (props: MedPrecibeProps) => {
  const {
    denialResons,
    handleSubmit,
    actionType,
    setActionType,
    rxChangeAlertsRequestData,
    medRequestSelectedData,
  } = props;
  const isPorURef = useRef(false);

  const isPorU = () => {
    if (
      rxChangeAlertsRequestData?.type === "P" ||
      rxChangeAlertsRequestData?.type === "U"
    ) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    isPorURef.current = isPorU();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rxChangeAlertsRequestData]);
  return (
    <>
      <Formik<RxChangeAlertForm>
        initialValues={initialFormValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}
      >
        {(registerProps) => (
          <Form onSubmit={registerProps.handleSubmit}>
            <Grid container xs={12} md={12}>
              <Grid item xs={0} sm={0} md={0} lg={4}></Grid>
              <Grid item xs={12} sm={12} md={12} lg={8}>
                <Grid container xs={12} md={12}>
                  {isPorURef.current && (
                    <>
                      <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Typography
                          component="label"
                          variant="body2"
                          htmlFor="paInformation"
                          marginLeft={{ lg: 2 }}
                          whiteSpace={"nowrap"}
                          paddingRight={1}
                        >
                          PA Information
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12} md={9} lg={9}>
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="Notes"
                              name="paInformation"
                              className=""
                              placeholder="Enter PA Information"
                              sx={{
                                padding: "4px 0px !important",
                              }}
                            />
                          </DRxInputStyle>
                        </Box>
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="reasonDenied"
                      marginLeft={{ lg: 2 }}
                      whiteSpace={"nowrap"}
                      paddingRight={1}
                    >
                      Denial Reason:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={9} lg={9}>
                    <Box>
                      <DRxSelectStyle>
                        <DRxSelect
                          id="reason"
                          name="reasonDenied"
                          data={
                            denialResons
                              ? [...denialResons]
                              : [{ label: "--Select Reason--", value: "0" }]
                          }
                          value={registerProps?.values?.reasonDenied}
                        />
                      </DRxSelectStyle>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Typography
                      component="label"
                      variant="body2"
                      htmlFor="note"
                      marginLeft={{ lg: 2 }}
                      whiteSpace={"nowrap"}
                      paddingRight={1}
                    >
                      Note:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={9} lg={9}>
                    <Box>
                      <DRxInput
                        id="refillNotes"
                        name="refillNotes"
                        placeholder="Enter Note"
                        multiline
                        rows={3}
                        fullWidth
                        value={registerProps?.values?.refillNotes}
                        sx={{
                          padding: "4px 0px !important",
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              item
              xs={12}
              spacing={0}
              alignItems="top"
              justifyContent="space-between"
              columnSpacing={5}
              marginTop={3}
              marginBottom={4}
            >
              <Grid item xs={12}>
                <BtnSMGroupStyle>
                  <YSButton
                    className={""}
                    children={"Back"}
                    variant={"outlined"}
                    type={"submit"}
                    size={"large"}
                    color="secondary"
                    id="back"
                    onClick={() => setActionType("Back")}
                  />
                  <YSButton
                    size="large"
                    className=""
                    color="secondary"
                    dataTestId="submitBtn"
                    variant="outlined"
                    disabled={false}
                    type="submit"
                    children={
                      actionType === "Denied" ? (
                        <CircularProgress color="primary" size={28} />
                      ) : (
                        "Denied"
                      )
                    }
                    id="denied"
                    onClick={() => setActionType("Denied")}
                  />{" "}
                  <YSButton
                    size="large"
                    className=""
                    color="secondary"
                    dataTestId="submitBtn"
                    variant="outlined"
                    disabled={false}
                    type="submit"
                    children={
                      actionType === "Approved With Changes" ? (
                        <CircularProgress color="primary" size={28} />
                      ) : (
                        "Approved With Changes"
                      )
                    }
                    id="Approved With Changes"
                    onClick={() => setActionType("Approved With Changes")}
                  />
                  <YSButton
                    size="large"
                    className=""
                    color="primary"
                    dataTestId="submitBtn"
                    variant="contained"
                    disabled={medRequestSelectedData?.scheduleDrug}
                    type="submit"
                    children={
                      actionType === "Approved" ? (
                        <CircularProgress color="inherit" size={28} />
                      ) : (
                        "Approved"
                      )
                    }
                    id="Approved"
                    onClick={() => setActionType("Approved")}
                  />
                </BtnSMGroupStyle>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default React.memo(MedPrescribedForm);
